module.exports = __webpack_public_path__ + "static/media/15UN-Habitat8.e5c47ca0.jpg";